import { parseUrl } from "../url/url.ts";
import { currentIdentity } from "./browser.ts";
import {
  applyIdentityToUrl,
  shouldCarryClientId,
  shouldCarrySession,
} from "./carry.ts";
import { clientIdParam } from "./clientId.ts";
import { sessionParam } from "./session.ts";

// Absent id omitted: String(null) would submit "null".
function setHiddenInput(
  formElement: HTMLFormElement,
  name: string,
  value: string | null,
) {
  if (value === null) {
    return;
  }

  // A visible input with this name belongs to the page: leave it alone.
  const visible = formElement.querySelector<HTMLInputElement>(
    `input[name="${name}"]:not([type="hidden"])`,
  );
  if (visible) {
    return;
  }

  // Re-submit reuses the input: appending would send the param twice.
  const existing = formElement.querySelector<HTMLInputElement>(
    `input[type="hidden"][name="${name}"]`,
  );
  if (existing) {
    existing.value = value;
    return;
  }

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = name;
  input.value = value;
  formElement.append(input);
}

function initCrossDomainLinker(): void {
  document.addEventListener("click", (event) => {
    const anchorElement = (
      event.target as HTMLElement
    ).closest<HTMLAnchorElement>("a[href]");

    if (!anchorElement) {
      return;
    }

    const carried = applyIdentityToUrl(anchorElement.href);
    // Nothing carried → leave the attribute alone, else a relative href turns absolute.
    if (carried !== anchorElement.href) {
      anchorElement.href = carried;
    }
  });

  document.addEventListener("submit", (event) => {
    const formElement = (event.target as HTMLElement).closest<HTMLFormElement>(
      "form[action]",
    );
    // IDL property, not the attribute: absent `method` normalises to "get".
    if (formElement?.method !== "get") {
      return;
    }

    const identity = currentIdentity();
    const target = parseUrl(formElement.action);
    const from = parseUrl(identity.from);
    if (target === null || from === null) {
      return;
    }

    if (shouldCarrySession(target, from)) {
      setHiddenInput(formElement, sessionParam, identity.sessionUuid);
    }
    if (shouldCarryClientId(target, from)) {
      setHiddenInput(formElement, clientIdParam, identity.clientId);
    }
  });
}

export { initCrossDomainLinker };
